export default "__VITE_ASSET__B9vgaqCZ__"